import { Tooltip } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import React from 'react';

interface IncompleteIconProps {
  msg?: string;
  color?: string;
  overlayInnerStyle?: React.CSSProperties;
}

export const IncompleteIcon = (props: IncompleteIconProps) => {
  const { msg = 'Scope is incomplete', color, overlayInnerStyle } = props;
  return (
    <Tooltip title={msg} color={color} overlayInnerStyle={overlayInnerStyle}>
      <ExclamationCircleFilled />
    </Tooltip>
  );
};
